export default {
  computed: {
    allWhatsappStatus() {
      return {
        ONLINE: {
          text: 'Online',
          color: '#26a95d',
        },
        OFFLINE: {
          text: 'Offline',
          color: '#e74c3c',
        },
        INACTIVE: {
          text: 'Indisponível',
          color: '#d2d6d9',
        },
        AUTOMATION_OFFLINE: {
          text: 'Apenas Broadcast',
          color: '#ffe336',
        },
        CONNECTING: {
          text: 'Conectando',
          color: '#ffe336',
        },
      }
    },
  },
  methods: {
    statusText(status) {
      return this.allWhatsappStatus[status]?.text ?? this.allWhatsappStatus.CONNECTING.text
    },
    statusColor(status) {
      return this.allWhatsappStatus[status]?.color ?? this.allWhatsappStatus.CONNECTING.color
    },
  },
}
